<template>
  <div class="form-view">
    <div class="content-list-view">
      <!-- 融资上市 -->
      <el-form
        :model="RZSSForm"
        :rules="RZSSRules"
        class="login-form"
        ref="RZSSForm"
        label-width="184px"
        :disabled="editState"
      >
        <el-form-item label="融资轮数:">
          <el-select
            style="width: 240px"
            v-model="RZSSForm.rzls"
            placeholder="请选择融资轮数"
          >
            <el-option
              v-for="item in rzlsList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有融资需求:">
          <el-radio-group v-model="RZSSForm.sfyrzxq" @change="sfyrzxqChange">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="融资方式:"
          prop="rzfs"
          v-if="RZSSForm.sfyrzxq == 1"
        >
          <el-radio-group v-model="RZSSForm.rzfs" @change="rzfsChange">
            <el-radio label="1">债权融资</el-radio>
            <el-radio label="2">股权融资</el-radio>
            <el-radio label="3">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="RZSSForm.rzfs == 1"
          label="债权融资需求金额:"
          prop="zqrzxqje"
        >
          <el-select
            style="width: 240px"
            v-model="RZSSForm.zqrzxqje"
            placeholder="请选择债权融资需求金额"
          >
            <el-option
              v-for="item in zqrzxqjeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="RZSSForm.rzfs == 2"
          label="股权融资需求金额:"
          prop="gqrzxqje"
        >
          <el-select
            style="width: 240px"
            v-model="RZSSForm.gqrzxqje"
            placeholder="请选择股权融资需求金额"
          >
            <el-option
              v-for="item in zqrzxqjeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否上市:">
          <el-radio-group v-model="RZSSForm.sfss" @change="sfssChange">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="RZSSForm.sfss == '0'"
          label="是否有上市计划:"
          prop="sfyssjh"
        >
          <el-select
            style="width: 240px"
            v-model="RZSSForm.sfyssjh"
            placeholder="请选择股权融资需求金额"
          >
            <el-option
              v-for="item in sfyssjhList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="RZSSForm.sfyssjh == '1'"
          label="计划上市模块:"
          prop="jhssmk"
        >
          <el-select
            style="width: 240px"
            v-model="RZSSForm.jhssmk"
            placeholder="请选择计划上市模块"
          >
            <el-option
              v-for="item in jhssmkList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="RZSSForm.sfss == '1'" label="上市模块:" prop="ssmk">
          <el-select
            style="width: 240px"
            v-model="RZSSForm.ssmk"
            placeholder="请选择上市模块"
          >
            <el-option
              v-for="item in jhssmkList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="control-view">
      <el-button
        type="primary"
        style="margin-top: 10px; padding: 10px 27px"
        @click="editForm"
        v-if="editState"
      >
        编辑
      </el-button>
      <el-button
        type="primary"
        style="margin-top: 10px; padding: 10px 27px"
        v-if="!editState"
        @click="saveInfo"
      >
        保存
      </el-button>
    </div>
  </div>
</template>

<script>
import { getRegisterUserEdit, getByToken2 } from "@/api/app";
import RZSS from "@/views/register/modules/RZSS";
export default {
  mixins: [RZSS],
  data() {
    return {
      editState: true
    };
  },
  beforeMount() {
    this.getByToken2();
  },
  methods: {
    editForm() {
      this.editState = false;
    },
    async getByToken2() {
      let { data } = await getByToken2();
      let params = {};
      for (const key in this.RZSSForm) {
        if (data[key]) {
          params[key] = data[key];
        }
      }
      this.RZSSForm = Object.assign({}, this.RZSSForm, params);
    },
    /**提交 */
    saveInfo() {
      this.$refs["RZSSForm"].validate(async valid => {
        if (valid) {
          this.loading = true;
          let params = Object.assign({}, this.RZSSForm);
          getRegisterUserEdit(params)
            .then(res => {
              if (res.data) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.editState = true;
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.control-view {
  padding-left: 320px;
  & .el-button {
    background: rgba(41, 99, 204, 1);
    border-color: rgba(41, 99, 204, 1);
  }
}
</style>
